export default "__VITE_ASSET__D9oT8FTn__"